import axios from 'axios';

import { hasAdminAccess, isAdminPath } from '@/utils';

export const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
  // timeout: 45000,
});

export const axiosConfig = (Vue, { store, router }) => {
  Object.defineProperty(Vue.prototype, '$http', {
    get() {
      return axiosClient;
    },
  });

  // add authorization header on each request
  axiosClient.interceptors.request.use(request => {
    const route = router.app._route || {};

    const userToken = store.state.auth.pid;
    const impersonatedUserToken = store.state.auth.impid;

    const user = store.state.auth.user;
    const impersonatedUser = store.state.auth.impersonatedUser;

    const cond1 = isAdminPath(route.path) && user && hasAdminAccess(user);
    const cond2 = !isAdminPath(route.path) && user && hasAdminAccess(user) && impersonatedUser;

    const token = cond1 ? userToken : cond2 ? impersonatedUserToken : userToken;

    request.headers['Authorization'] = `Bearer ${token}`;
    request.headers['Accept'] = 'application/json';
    return request;
  });

  // redirect to login on unautorized response
  axiosClient.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const route = router.app._route || {};

      if (error && error.response && error.response.status && error.response.status === 401) {
        store.commit('auth/logout');

        if (isAdminPath(route.path) && route.path !== '/admin/login') {
          return router.push({ path: '/admin/login/' });
        }

        if (!isAdminPath(route.path) && route.path !== '/auth/login') {
          return router.push({ path: '/auth/login' });
        }
      }

      throw error;
    },
  );
};
